module.exports = __webpack_public_path__ + "img/ayun-qb.e27248e6.svg";